import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { MenuService } from "../../../shared/menu/menu.service";

@Component({
  selector: "platform-menu-button",
  templateUrl: "./menu-button.component.html",
  styleUrls: ["./menu-button.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuButtonComponent implements OnInit {
  isOpen = false;


  constructor(
    private menuService: MenuService
  ) { }

  ngOnInit() {
    this.menuService.isOpen$.subscribe(value => this.isOpen = value);
  }


  get iconName(): string {
    return this.isOpen ? "step-backward" : "bars";
  }

  toggleMenuState(): void {
    this.menuService.toggleMenuState();
  }
}
